import { useState, React } from 'react';
import { Steps, theme, } from 'antd';

const steps = [
  {
    content: 
    <><p>In Asana navigate to a project and select the Customise button in the top right corner</p>
    <img style={{ marginTop: 10 }} src="00.png" width='100%' alt="0" />
    </>,
  },
  {
    content: 
    <><p>In the Customise menu select Apps in the Add section and search for Attachment Manager</p>
    <img style={{ marginTop: 10 }} src="0.png" width='100%' alt="0" />
    </>,
  },
  {
    content: 
    <><p>Click Add to Project, accept EULA and authorize app</p>
    <img style={{ marginTop: 10 }} src="1.png" width='100%' alt="0" />
    </>,  
  },
  {
    content: 
    <><p>Open Asana task and click Add Downloader to add widget</p>
    <img style={{ marginTop: 10 }} src="2.png" width='100%' alt="0" />
    </>,   },
  {
    content: 
    <><p>Click on widget to open Attachment Manager</p>
    <img style={{ marginTop: 10 }} src="3.png" width='100%' alt="0" />
    </>,   },
];

const Free = () => {

  const { token } = theme.useToken();
  const [current, setCurrent] = useState(0);

  const contentStyle = {
    width: '68%',
    textAlign: 'center',
    color: token.colorTextTertiary,
    backgroundColor: token.colorFillAlter,
    borderRadius: token.borderRadiusLG,
    border: `1px dashed ${token.colorBorder}`,
    marginTop: 16,
  };

  const onChange = (value) => {
    console.log('onChange:', value);
    setCurrent(value);
  };

  return (
    <>
      <Steps
        type="navigation"
        size="small"
        current={current}
        onChange={onChange}
        className="site-navigation-steps"
        items={[
          {
            title: 'Open Asana Project',
            subTitle: 'Click ',
            status: 'process',
            description: 'Customise > Apps',
          },
          {
            title: 'Add App',
            subTitle: 'Find',
            status: 'process',
            description: 'Attachment Manager',
          },
          {
            title: 'Add to project',
            subTitle: 'Accept',
            status: 'process',
            description: 'UELA and authorize',
          },
          {
            title: 'Add widget to task',
            subTitle: 'Click',
            status: 'process',
            description: 'Add widget',
          },
          {
            title: 'Use Downloader',
            subTitle: 'Click',
            status: 'process',
            description: 'To open the app',
          },
        ]}
      />
      <center><div style={contentStyle}>{steps[current].content}</div></center>
    </>
  );
};

export default Free;